/* unplugin-vue-components disabled */import script from "./OtherReasonModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OtherReasonModal.vue?vue&type=script&setup=true&lang=ts"

import "./OtherReasonModal.vue?vue&type=style&index=0&id=647cb186&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-647cb186"]])

export default __exports__